import React, { useEffect, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

// images
import Basket from "../images/basket.gif";
import Logo from "../images/25.png";

import moment from "moment";

import { db } from "./firebase";
import { collection, getDocs, query, where } from "firebase/firestore";

import GiftJSON from "../data/gift.json";

// components
import "antd/dist/antd.css";
import {
  Card,
  Button,
  Typography,
  Row,
  Col,
  Badge,
  InputNumber,
  message,
  Affix,
  Popconfirm,
  Drawer,
  Spin,
  Space,
  Divider,
  Checkbox,
  Progress,
  Modal,
  Radio,
} from "antd";

import {
  QuestionCircleOutlined,
  DeleteOutlined,
  LeftCircleOutlined,
  ShoppingOutlined,
  EditOutlined,
  CheckCircleOutlined,
} from "@ant-design/icons";

const { Title } = Typography;

function Cart() {
  let navigate = useNavigate();

  const gifts = GiftJSON;

  const [visible, setVisible] = useState(false);
  const [cart, setCart] = useState(null);
  const [gift, setGift] = useState(null);
  // const [gift, setGift] = useState([
  //   {
  //     condition: 7000,
  //     name: "โทรทัศน์",
  //   },

  //   {
  //     condition: 6000,
  //     name: "เครื่องคอม",
  //   },
  //   {
  //     condition: 5000,
  //     name: "ตู้เย็น",
  //   },
  //   {
  //     condition: 6000,
  //     name: "เครื่องซักผ้า",
  //   },
  // ]);
  const [option, setOption] = useState([]);
  const [loading, setLoading] = useState(false);
  const [checked, setChecked] = useState(null);
  const [item, setItem] = useState(null);
  const [reoption, setReoption] = useState(false);
  const [idx, setIdx] = useState(null);

  useEffect(() => {
    setLoading(true);

    checkStatusWeb();
    getCartandGifts();
    getPackages();

    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  const checkStatusWeb = async () => {
    const querySnapshot = await getDocs(
      query(collection(db, "control_web"), where("isactive", "==", false))
    );

    const res = querySnapshot.docs
      .map((doc) => doc.data())
      .filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
            moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
            moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
      );

    if (res.length !== 0) {
      navigate("/maintain");
    }
  };

  const getCartandGifts = async () => {
    // getCart //

    if (
      JSON.parse(localStorage.getItem("Cart")) &&
      JSON.parse(localStorage.getItem("Cart")).length !== 0
    ) {
      const querySnapshot = await getDocs(
        query(collection(db, "packages"), where("isactive", "==", true))
      );
      const allPack = querySnapshot.docs.map((doc) => doc.data());

      const cartPack = JSON.parse(localStorage.getItem("Cart")).filter(
        (x) =>
          moment().format("YYYY-MM-DD HH:mm:ss") >=
            moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
          moment().format("YYYY-MM-DD HH:mm:ss") <=
            moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss") &&
          x.isactive === true
      );

      let arr = [];
      for (let i = 0; i < allPack.length; i++) {
        for (let j = 0; j < cartPack.length; j++) {
          if (
            allPack[i].ecoupon_code === cartPack[j].ecoupon_code &&
            allPack[i].isactive === cartPack[j].isactive &&
            allPack[i].start_date === cartPack[j].start_date &&
            allPack[i].end_date === cartPack[j].end_date
          ) {
            arr.push(cartPack[j]);
          }
        }
      }

      // ตรวจสอบและแปลง 26Pro01 เป็น 26Pro06 หากจำนวน >= 2
      arr = arr.map((item) => {
        if (item.ecoupon_code === "26Pro01" && item.qty >= 2) {
          return {
            ...item,
            ecoupon_code: "26Pro06",
            name: "โปรแกรมวัคซีนไข้หวัดใหญ่ WE ARE BACK STRONGER 1 เข็ม อายุ 7 ปีขึ้นไป (กรณีซื้อ 2 เข็มขึ้นไป) ราคา 250 บาท",
            price_pro: 250
          };
        }
        return item;
      });

      setCart(arr);

      localStorage.removeItem("Cart");
      localStorage.setItem("Cart", JSON.stringify(arr));

      // getGifts //

      const querySnapshot2 = await getDocs(
        query(collection(db, "gift"), where("isactive", "==", true))
      );

      const gifts = querySnapshot2.docs
        .map((doc) => doc.data())
        .filter(
          (x) =>
            moment().format("YYYY-MM-DD HH:mm:ss") >=
              moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
            moment().format("YYYY-MM-DD HH:mm:ss") <=
              moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
        );

      if (gifts.length === 0) {
        setGift(null);
      } else {
        setGift(gifts);

        if (
          JSON.parse(localStorage.getItem("Gift")) &&
          JSON.parse(localStorage.getItem("Gift")) !== null
        ) {
          setValue(JSON.parse(localStorage.getItem("Gift")));
        } else {
          if (gifts !== null && gifts.length !== 0) {
            for (let i = 0; i < gifts.length; i++) {
              if (
                arr.reduce((accumulator, object) => {
                  return accumulator + object.price_pro * object.qty;
                }, 0) >=
                gifts.sort((a, b) => {
                  if (a.condition > b.condition) {
                    return -1;
                  }
                })[i].condition
              ) {
                localStorage.setItem("Gift", JSON.stringify(gifts[i].name));
                setValue(gifts[i].name);
                break;
              } else {
                localStorage.setItem("Gift", JSON.stringify(null));
                setValue(null);
              }
            }
          }
        }
      }
    }
  };

  const getPackages = async () => {
    const querySnapshot = await getDocs(
      query(
        collection(db, "packages"),
        where("isactive", "==", true),
        where("type", "==", "option")
      )
    );
    const pcks = querySnapshot.docs.map((doc) => doc.data());

    const option = pcks.filter(
      (x) =>
        // (x.ecoupon_code === id || x.promotion === id) &&
        moment().format("YYYY-MM-DD HH:mm:ss") >=
          moment().format(x.start_date, "YYYY-MM-DD HH:mm:ss") &&
        moment().format("YYYY-MM-DD HH:mm:ss") <=
          moment().format(x.end_date, "YYYY-MM-DD HH:mm:ss")
      //  &&
      // x.isactive === true
    );

    if (option.length !== 0) {
      setOption(option);
    }
    //  else {
    //   navigate("/");
    // }
  };

  const onChange = (e) => {
    if (e.checked === false) {
      setChecked(
        checked.filter((x) => x.ecoupon_code !== e.value.ecoupon_code)
      );
    } else {
      e.value["qty"] = 1;
      e.value["idx"] = idx;

      setChecked([...checked, e.value]);
    }
  };

  const onClose = () => {
    setVisible(false);
  };

  const confirmSubPackages = () => {
    setReoption(true);
    setTimeout(() => {
      setReoption(false);
    }, 500);

    let current_coupon = cart.filter(
      (x) => x.idx === idx && x.ecoupon_code === item.ecoupon_code
    );
    let old_cart = cart.filter((x) => x.idx !== idx);

    for (let i = 0; i < old_cart.length; i++) {
      checked.push(old_cart[i]);
    }
    checked.push(current_coupon[0]);

    localStorage.removeItem("Cart");
    localStorage.setItem("Cart", JSON.stringify(checked));

    message.success("แก้ไขสินค้าแล้ว");
    setCart(checked);
    setVisible(false);
  };

  const handleAdd = (product) => {

    // console.log(product)

    let handleCart = cart.map((x) =>
      x.ecoupon_code === product.ecoupon_code ? { ...x, qty: x.qty + 1 } : x
    );

    // ถ้าเป็น 26Pro01 และจำนวน >= 2 ให้เปลี่ยนเป็น 26Pro06
    if (product.ecoupon_code === "26Pro01") {
      const itemIndex = handleCart.findIndex(x => x.ecoupon_code === "26Pro01");
      if (itemIndex !== -1 && handleCart[itemIndex].qty >= 2) {
        handleCart[itemIndex] = {
          ...handleCart[itemIndex],
          ecoupon_code: "26Pro06",
          name: "โปรแกรมวัคซีนไข้หวัดใหญ่ WE ARE BACK STRONGER 1 เข็ม อายุ 7 ปีขึ้นไป (กรณีซื้อ 2 เข็มขึ้นไป) ราคา 250 บาท",
          price_pro: 250
        };
      }
    }

    setCart(handleCart);

    if (gift !== null && gift.length !== 0) {
      for (let i = 0; i < gift.length; i++) {
        if (
          handleCart.reduce((accumulator, object) => {
            return accumulator + object.price_pro * object.qty;
          }, 0) >=
          gift.sort((a, b) => {
            if (a.condition > b.condition) {
              return -1;
            }
          })[i].condition
        ) {
          localStorage.setItem("Gift", JSON.stringify(gift[i].name));
          setValue(gift[i].name);
          break;
        } else {
          localStorage.setItem("Gift", JSON.stringify(null));
          setValue(null);
        }
      }
    }

    localStorage.removeItem("Cart");
    localStorage.setItem("Cart", JSON.stringify(handleCart));
  };

  const handleDel = (product) => {

    // console.log(product)

    if (product.qty === 1) {
      removeProduct(product);
    } else {
      let handleCart = cart.map((x) =>
        x.ecoupon_code === product.ecoupon_code ? { ...x, qty: x.qty + -1 } : x
      );

      // ถ้าเป็น 26Pro06 และจำนวนลดลงมาน้อยกว่า 2 ให้เปลี่ยนกลับเป็น 26Pro01
      if (product.ecoupon_code === "26Pro06") {
        const itemIndex = handleCart.findIndex(x => x.ecoupon_code === "26Pro06");
        if (itemIndex !== -1 && handleCart[itemIndex].qty < 2) {
          handleCart[itemIndex] = {
            ...handleCart[itemIndex],
            ecoupon_code: "26Pro01",
            name: "โปรแกรมวัคซีนไข้หวัดใหญ่ WE ARE BACK STRONGER 1 เข็ม อายุ 7 ปีขึ้นไป ราคา 350 บาท",
            price_pro: 350
          };
        }
      }

      setCart(handleCart);

      if (gift !== null && gift.length !== 0) {
        for (let i = 0; i < gift.length; i++) {
          if (
            handleCart.reduce((accumulator, object) => {
              return accumulator + object.price_pro * object.qty;
            }, 0) >=
            gift.sort((a, b) => {
              if (a.condition > b.condition) {
                return -1;
              }
            })[i].condition
          ) {
            localStorage.setItem("Gift", JSON.stringify(gift[i].name));
            setValue(gift[i].name);
            break;
          } else {
            localStorage.setItem("Gift", JSON.stringify(null));
            setValue(null);
          }
        }
      }

      localStorage.removeItem("Cart");
      localStorage.setItem("Cart", JSON.stringify(handleCart));
    }
  };

  const handleInput = (product, value) => {
    if (value === null) {
      let handleCart = cart.map((x) =>
        x.ecoupon_code === product.ecoupon_code ? { ...x, qty: 1 } : x
      );

      // ถ้าเป็น 26Pro01 และจำนวน >= 2 ให้เปลี่ยนเป็น 26Pro06
      if (product.ecoupon_code === "26Pro01" && 1 >= 2) {
        const itemIndex = handleCart.findIndex(x => x.ecoupon_code === "26Pro01");
        if (itemIndex !== -1) {
          handleCart[itemIndex] = {
            ...handleCart[itemIndex],
            ecoupon_code: "26Pro06",
            name: "โปรแกรมวัคซีนไข้หวัดใหญ่ WE ARE BACK STRONGER 1 เข็ม อายุ 7 ปีขึ้นไป (กรณีซื้อ 2 เข็มขึ้นไป) ราคา 250 บาท",
            price_pro: 250
          };
        }
      }
      // ถ้าเป็น 26Pro06 และจำนวนลดลงมาน้อยกว่า 2 ให้เปลี่ยนกลับเป็น 26Pro01
      if (product.ecoupon_code === "26Pro06" && 1 < 2) {
        const itemIndex = handleCart.findIndex(x => x.ecoupon_code === "26Pro06");
        if (itemIndex !== -1) {
          handleCart[itemIndex] = {
            ...handleCart[itemIndex],
            ecoupon_code: "26Pro01",
            name: "โปรแกรมวัคซีนไข้หวัดใหญ่ WE ARE BACK STRONGER 1 เข็ม อายุ 7 ปีขึ้นไป ราคา 350 บาท",
            price_pro: 350
          };
        }
      }

      setCart(handleCart);

      if (gift !== null && gift.length !== 0) {
        for (let i = 0; i < gift.length; i++) {
          if (
            handleCart.reduce((accumulator, object) => {
              return accumulator + object.price_pro * object.qty;
            }, 0) >=
            gift.sort((a, b) => {
              if (a.condition > b.condition) {
                return -1;
              }
            })[i].condition
          ) {
            localStorage.setItem("Gift", JSON.stringify(gift[i].name));
            setValue(gift[i].name);
            break;
          } else {
            localStorage.setItem("Gift", JSON.stringify(null));
            setValue(null);
          }
        }
      }

      localStorage.removeItem("Cart");
      localStorage.setItem("Cart", JSON.stringify(handleCart));
    } else {
      let handleCart = cart.map((x) =>
        x.ecoupon_code === product.ecoupon_code ? { ...x, qty: value } : x
      );

      // ถ้าเป็น 26Pro01 และจำนวน >= 2 ให้เปลี่ยนเป็น 26Pro06
      if (product.ecoupon_code === "26Pro01" && value >= 2) {
        const itemIndex = handleCart.findIndex(x => x.ecoupon_code === "26Pro01");
        if (itemIndex !== -1) {
          handleCart[itemIndex] = {
            ...handleCart[itemIndex],
            ecoupon_code: "26Pro06",
            name: "โปรแกรมวัคซีนไข้หวัดใหญ่ WE ARE BACK STRONGER 1 เข็ม อายุ 7 ปีขึ้นไป (กรณีซื้อ 2 เข็มขึ้นไป) ราคา 250 บาท",
            price_pro: 250
          };
        }
      }
      // ถ้าเป็น 26Pro06 และจำนวนลดลงมาน้อยกว่า 2 ให้เปลี่ยนกลับเป็น 26Pro01
      if (product.ecoupon_code === "26Pro06" && value < 2) {
        const itemIndex = handleCart.findIndex(x => x.ecoupon_code === "26Pro06");
        if (itemIndex !== -1) {
          handleCart[itemIndex] = {
            ...handleCart[itemIndex],
            ecoupon_code: "26Pro01",
            name: "โปรแกรมวัคซีนไข้หวัดใหญ่ WE ARE BACK STRONGER 1 เข็ม อายุ 7 ปีขึ้นไป ราคา 350 บาท",
            price_pro: 350
          };
        }
      }

      setCart(handleCart);

      if (gift !== null && gift.length !== 0) {
        for (let i = 0; i < gift.length; i++) {
          if (
            handleCart.reduce((accumulator, object) => {
              return accumulator + object.price_pro * object.qty;
            }, 0) >=
            gift.sort((a, b) => {
              if (a.condition > b.condition) {
                return -1;
              }
            })[i].condition
          ) {
            localStorage.setItem("Gift", JSON.stringify(gift[i].name));
            setValue(gift[i].name);
            break;
          } else {
            localStorage.setItem("Gift", JSON.stringify(null));
            setValue(null);
          }
        }
      }

      localStorage.removeItem("Cart");
      localStorage.setItem("Cart", JSON.stringify(handleCart));
    }
  };

  const removeProduct = (product) => {
    let handleCart = null;

    if (product.type === "event") {
      handleCart = cart
        .filter((x) => x.idx !== product.idx)
        .map((x) =>
          x.type === "promotion_season"
            ? {
                ...x,
                // ecoupon_code: x.n_ecoupon_code,
                price_pro: x.n_price_pro,
                type: x.n_type,
                ecoupon_code: x.n_ecoupon_code,
                event: x.n_event,
                img: x.n_img,
              }
            : x
        );
    } else {
      handleCart = cart.filter((x) => x.ecoupon_code !== product.ecoupon_code);
    }

    setCart(handleCart);

    if (gift !== null && gift.length !== 0) {
      for (let i = 0; i < gift.length; i++) {
        if (
          handleCart.reduce((accumulator, object) => {
            return accumulator + object.price_pro * object.qty;
          }, 0) >=
          gift.sort((a, b) => {
            if (a.condition > b.condition) {
              return -1;
            }
          })[i].condition
        ) {
          localStorage.setItem("Gift", JSON.stringify(gift[i].name));
          setValue(gift[i].name);
          break;
        } else {
          localStorage.setItem("Gift", JSON.stringify(null));
          setValue(null);
        }
      }
    }

    localStorage.removeItem("Cart");
    localStorage.setItem("Cart", JSON.stringify(handleCart));

    message.success("ลบสินค้าแล้ว");
  };

  const Loading = () => {
    return (
      <div className="center">
        <img src={Basket} style={{ width: "20%" }} alt="" />
        <br /> <p>Loading...</p>
      </div>
    );
  };

  const showDrawer = (product) => {
    setIdx(product.idx);
    setItem(product);
    setChecked(cart.filter((x) => x.idx === product.idx && x.type !== "event"));
    setReoption(true);
    setTimeout(() => {
      setReoption(false);
    }, 500);
    setVisible(true);
  };

  const [value, setValue] = useState(null);
  const [visibleModal, setVisibleModal] = useState(false);

  const onChangeRadio = (e) => {
    localStorage.setItem("Gift", JSON.stringify(e.target.value));
    setValue(e.target.value);
  };

  return (
    <div>
      <Affix offsetTop={0}>
        <div
          style={{
            padding: "20px",
            background: "rgba(255,255,255,0.8)",
            lineHeight: "130%",
          }}
        >
          <>
            <Row>
              <Col style={{ textAlign: "left" }}>
                <LeftCircleOutlined
                  style={{
                    fontSize: "20px",
                    marginTop: "10px",
                    marginRight: "20px",
                    color: "#1e366f",
                  }}
                  onClick={() => window.history.back()}
                />
              </Col>
              <Col flex="auto" style={{ textAlign: "left" }}>
                <span
                  style={{
                    color: "white",
                    fontSize: "20px",
                    paddingRight: "10px",
                  }}
                >
                  <NavLink to="/">
                    {" "}
                    <b>
                      <span style={{ color: "#1e366f", fontSize: "16px" }}>
                        {/* <img src={Logo} alt="" width={35} />  */} Bangkok
                        Hospital Hatyai <br />
                        <span style={{ color: "#b21e2a", fontSize: "14px" }}>
                          Shopping World
                        </span>
                      </span>
                    </b>
                  </NavLink>
                </span>
              </Col>
              <Col style={{ textAlign: "right" }}>
                <NavLink to="/cart">
                  <Badge
                    count={
                      cart != null
                        ? cart.filter((x) => x.type !== "option").length
                        : null
                    }
                  >
                    <div style={{ background: "white", borderRadius: "25px" }}>
                      <ShoppingOutlined
                        style={{
                          color: "#1e366f",
                          fontSize: "28px",
                          padding: "7px",
                        }}
                      />
                    </div>
                  </Badge>
                </NavLink>
              </Col>
            </Row>
          </>
        </div>
        <Divider style={{ margin: "0px" }} />
      </Affix>
      {loading ? (
        <Loading />
      ) : (
        <>
          <br />

          <div style={{ minHeight: "80vh" }}>
            {cart != null && cart.length != 0 ? (
              cart
                .filter((x) => x.type !== "option")
                .map((product) => {
                  return (
                    <>
                      {/* <Title
                        level={4}
                        style={{
                          textAlign: "center",
                          marginTop: "10px",
                          marginBottom: "10px",
                        }}
                      >
                        ตะกร้า
                      </Title> */}
                      <div
                        hoverable
                        style={{
                          background: "white",
                          borderRadius: "25px",
                          height: "100%",
                          marginLeft: "10px",
                          marginRight: "10px",
                          marginBottom: "10px",
                          boxShadow: "1px 2px 10px silver",
                          padding: "20px",
                        }}
                      >
                        <Row>
                          <Col span={7} style={{ textAlign: "left" }}>
                            <Button
                              disabled={product.qty <= 1 ? true : false}
                              onClick={() => handleDel(product)}
                              size="small"
                            >
                              -
                            </Button>
                            <InputNumber
                              style={{
                                width: "30px",
                                textAlign: "center",
                              }}
                              size="small"
                              min={1}
                              max={
                                product.type === "event"
                                  ? 1
                                  : product.max_coupon
                              }
                              defaultValue={1}
                              value={product.qty}
                              onChange={(value) => handleInput(product, value)}
                            />
                            {product.type === "event" ? (
                              <Button
                                size="small"
                                onClick={() => handleAdd(product)}
                                disabled={product.qty >= 1 ? true : false}
                              >
                                +
                              </Button>
                            ) : (
                              <Button
                                size="small"
                                onClick={() => handleAdd(product)}
                                disabled={
                                  product.qty >= product.max_coupon
                                    ? true
                                    : false
                                }
                              >
                                +
                              </Button>
                            )}
                          </Col>
                          <Col span={11} style={{ textAlign: "left" }}>
                            {product.name}
                          </Col>
                          <Col
                            span={6}
                            style={{ textAlign: "right", color: "#b21e2a" }}
                          >
                            <b>{product.price_pro.toLocaleString("en-US")} ฿</b>
                          </Col>
                        </Row>
                        {/* <Row> */}
                        <br />
                        {cart
                          .filter(
                            (x) => x.idx === product.idx && x.type === "option"
                          )
                          .map((x) => {
                            return (
                              <>
                                <Row>
                                  <Col span={18}>
                                    <span style={{ color: "#B1945F" }}>*</span>
                                    {x.name}
                                  </Col>
                                  <Col span={6} style={{ textAlign: "right" }}>
                                    {x.price_pro.toLocaleString("en-US")} ฿
                                  </Col>
                                </Row>
                                <br />
                              </>
                            );
                          })}
                        {/* <br/> */}

                        {/* </Row> */}

                        <div style={{ textAlign: "right" }}>
                          {/* <Col> */}
                          {/* {product.type === "event" ? (
                            <Button
                              type="primary"
                              // danger
                              size="small"
                              style={{
                                padding: 0,
                                width: "70px",
                                marginRight: "8px",
                                // background: "#BDB76B",
                                border: 0,
                              }}
                              onClick={() => showDrawer(product)}
                            >
                              <Row>
                                <Col span={18}>แก้ไข</Col>
                                <Col span={6} style={{ background: "#2874A6" }}>
                                  <EditOutlined />
                                </Col>
                              </Row>
                            </Button>
                          ) : null} */}
                          <Popconfirm
                            title="คุณต้องการลบสินค้านี้หรือไม่ ？"
                            icon={
                              <QuestionCircleOutlined
                                style={{
                                  color: "red",
                                }}
                              />
                            }
                            okText="ใช่"
                            cancelText="ไม่"
                            onConfirm={() => removeProduct(product)}
                            placement="topRight"
                          >
                            <Button
                              type="primary"
                              danger
                              size="small"
                              style={{ padding: 0, width: "60px", border: 0 }}
                            >
                              <Row>
                                <Col span={18}>ลบ</Col>
                                <Col span={6} style={{ background: "#B03A2E" }}>
                                  <DeleteOutlined />
                                </Col>
                              </Row>
                            </Button>
                          </Popconfirm>
                          {/* </Col> */}
                        </div>
                      </div>
                    </>
                  );
                })
            ) : (
              <center>
                <span className="center">ไม่มีแพ็คเกจในตะกร้า</span>
              </center>
            )}
          </div>
          {cart !== null && cart.length !== 0 ? (
            <>
              <Affix offsetBottom={0}>
                <div
                  style={{
                    padding: "20px",
                    backgroundColor: "white",
                    boxShadow: "0px 0px 10px #000000",
                  }}
                >
                  {gift !== null && gift.length !== 0 ? (
                    <>
                      <h3>เลือกของสมนาคุณ 1 รายการ</h3>
                      <br />
                      <Radio.Group onChange={onChangeRadio} value={value}>
                        <Space direction="vertical">
                          {cart !== null && cart.length !== 0
                            ? gift
                                .sort((a, b) => {
                                  if (a.condition < b.condition) {
                                    return -1;
                                  }
                                })
                                .map((product) => {
                                  return (
                                    <>
                                      <Radio
                                        disabled={
                                          product.condition <=
                                          cart.reduce((accumulator, object) => {
                                            return (
                                              accumulator +
                                              object.price_pro * object.qty
                                            );
                                          }, 0)
                                            ? false
                                            : true
                                        }
                                        value={product.name}
                                      >
                                        ซื้อครบ{" "}
                                        {product.condition.toLocaleString(
                                          "en-US"
                                        )}
                                        .-{" "}
                                        <span
                                          style={{
                                            color: "#b21e2a",
                                            paddingLeft: "6px",
                                          }}
                                        >
                                          รับฟรี
                                        </span>{" "}
                                        {product.name}
                                      </Radio>
                                    </>
                                  );
                                })
                            : null}
                        </Space>
                      </Radio.Group>
                      <Divider
                        style={{ marginTop: "18px", marginBottom: "18px" }}
                      />
                    </>
                  ) : null}

                  <Row>
                    <Col span={12} style={{ fontSize: "16px" }}>
                      รวมทั้งหมด{" "}
                      {cart !== null && cart.length !== 0 ? (
                        <b style={{ color: "#b21e2a" }}>
                          {cart
                            .reduce((accumulator, object) => {
                              return (
                                accumulator + object.price_pro * object.qty
                              );
                            }, 0)
                            .toLocaleString("en-US") + " ฿"}
                        </b>
                      ) : null}
                    </Col>
                    <Col span={12} style={{ textAlign: "right" }}>
                      <NavLink to="/">
                        <Button
                          type="primary"
                          style={{
                            color: "#1e366f",
                            borderColor: "#1e366f",
                            marginRight: "10px",
                          }}
                          ghost
                        >
                          สั่งซื้อเพิ่ม
                        </Button>
                      </NavLink>
                      <NavLink to="/info">
                        <Button
                          type="primary"
                          style={{
                            // paddingLeft: "15px",
                            // paddingRight: "15px",
                            background: "#1e366f",
                            border: 0,
                          }}
                        >
                          ยืนยัน
                        </Button>
                      </NavLink>
                    </Col>
                  </Row>
                </div>
              </Affix>
            </>
          ) : null}

          <Drawer
            title={item != null ? item.name : null}
            placement="bottom"
            onClose={onClose}
            visible={visible}
            height={500}
            extra={
              <Space>
                <Button
                  size="small"
                  onClick={onClose}
                  style={{ borderRadius: "25px" }}
                >
                  ยกเลิก
                </Button>
                <Button
                  size="small"
                  type="primary"
                  onClick={() => confirmSubPackages()}
                  style={{
                    borderRadius: "25px",
                    background: "#1e366f",
                    border: 0,
                  }}
                >
                  ยืนยัน
                </Button>
              </Space>
            }
          >
            <Divider orientation="center">
              โปรแกรม Option ที่ได้รับส่วนลดพิเศษ
            </Divider>

            {reoption ? (
              <Spin spinning={reoption}>
                <div
                  style={{
                    textAlign: "center",
                    padding: "10px",
                  }}
                >
                  <Row>
                    <Col span={2}></Col>
                    <Col span={12}>โปรแกรมตรวจ</Col>
                    <Col span={5}>ราคาปกติ</Col>
                    <Col span={5}>ราคาพิเศษ</Col>
                  </Row>
                </div>

                {option !== null && item !== null
                  ? option
                      .filter((x) => x.event === item.ecoupon_code)
                      .map(
                        (product) => (
                          // product.type === "option" && product.isactive === true ? (
                          <div
                            style={{
                              textAlign: "center",
                              padding: "10px",
                              marginBottom: "5px",
                              boxShadow: "1px 2px 5px silver",
                            }}
                          >
                            <Row>
                              <Col span={2}>
                                <Checkbox
                                  defaultChecked={
                                    checked !== null
                                      ? checked.find(
                                          (x) =>
                                            x.ecoupon_code ===
                                            product.ecoupon_code
                                        )
                                        ? true
                                        : false
                                      : false
                                  }
                                  value={product}
                                  onChange={(e) => onChange(e.target)}
                                />
                              </Col>
                              <Col
                                span={12}
                                style={{
                                  textAlign: "left",
                                  paddingLeft: "10px",
                                }}
                              >
                                {product.name}
                                <br />
                                {product.detail != "-" ? (
                                  <span
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {product.detail}
                                  </span>
                                ) : null}
                              </Col>
                              <Col
                                span={5}
                                style={{
                                  textDecoration: "line-through",
                                  textDecorationColor: "red",
                                }}
                              >
                                <span style={{ color: "silver" }}>
                                  {product.price.toLocaleString("en-US")}
                                </span>
                              </Col>
                              <Col span={5} style={{ color: "#b21e2a" }}>
                                <b>
                                  {product.price_pro.toLocaleString("en-US")}
                                </b>
                              </Col>
                            </Row>
                          </div>
                        )
                        // : null
                      )
                  : null}
              </Spin>
            ) : (
              <>
                <div
                  style={{
                    textAlign: "center",
                    padding: "10px",
                  }}
                >
                  <Row>
                    <Col span={2}></Col>
                    <Col span={12}>โปรแกรมตรวจ</Col>
                    <Col span={5}>ราคาปกติ</Col>
                    <Col span={5}>ราคาพิเศษ</Col>
                  </Row>
                </div>

                {option !== null && item !== null
                  ? option
                      .filter((x) => x.event === item.ecoupon_code)
                      .map(
                        (product) => (
                          // product.type === "option" && product.isactive === true ? (
                          <div
                            style={{
                              textAlign: "center",
                              padding: "10px",
                              marginBottom: "5px",
                              boxShadow: "1px 2px 5px silver",
                            }}
                          >
                            <Row>
                              <Col span={2}>
                                <Checkbox
                                  defaultChecked={
                                    checked !== null
                                      ? checked.find(
                                          (x) =>
                                            x.ecoupon_code ===
                                            product.ecoupon_code
                                        )
                                        ? true
                                        : false
                                      : false
                                  }
                                  value={product}
                                  onChange={(e) => onChange(e.target)}
                                  style={{ color: "silver" }}
                                />
                              </Col>
                              <Col
                                span={12}
                                style={{
                                  textAlign: "left",
                                  paddingLeft: "10px",
                                }}
                              >
                                {product.name}
                                <br />
                                {product.detail != "-" ? (
                                  <span
                                    style={{ color: "red", fontSize: "12px" }}
                                  >
                                    {product.detail}
                                  </span>
                                ) : null}
                              </Col>
                              <Col
                                span={5}
                                style={{
                                  textDecoration: "line-through",
                                  textDecorationColor: "red",
                                }}
                              >
                                <span style={{ color: "silver" }}>
                                  {product.price.toLocaleString("en-US")}
                                </span>
                              </Col>
                              <Col span={5} style={{ color: "#b21e2a" }}>
                                <b>
                                  {product.price_pro.toLocaleString("en-US")}
                                </b>
                              </Col>
                            </Row>
                          </div>
                        )
                        // ) : null
                      )
                  : null}
              </>
            )}
          </Drawer>
        </>
      )}
    </div>
  );
}

export default Cart;
